import {isEmpty} from '@shared/helpers/lang'

import {initPurchaseConfirmation} from '@web/actions/purchaseConfirmation'
import makeSlice from '@web/slices/purchaseConfirmation/sliceMaker'

const purchaseConfirmationSlice = makeSlice({
    extraReducers: (builder) => {
        builder.addCase(initPurchaseConfirmation.fulfilled, (state, {payload: {data, clickedId}}) => {
            state.isC3Item = data.c3Item ?? false
            state.containedPreOrderProduct = data.preOrderProduct ?? false
            state.remainedDeposit = data.depositRemained ?? false
            state.progressingDeliveryNo = data.progressDeliveryNo ?? ''
            state.isInfiniteExtended = data.infiniteExtended ?? false
            state.representationClaimStatusType = data.representationClaimStatusType
            state.targetInfo = !isEmpty(data.purchaseDecisionTargets)
                ? data.purchaseDecisionTargets.map((target) => {
                      return {
                          saleChannelType: target.saleChannelType ?? null,
                          productOrderNo: target.productOrderNo,
                          naverBenefit: target.naverBenefit,
                          productImageUrl: target.productImageUrl,
                          productName: target.productName,
                          merchantName: target.merchantName,
                          optionContents: target.optionContents,
                          isFamilyPay: target.familyPay,
                          claimStatusType: target.claimStatusType,
                      }
                  })
                : []

            /**
             * - 구매확정 대상상품이 1개일때는 자동 선택
             * - 외부에서 특정 상품 클릭하여 들어온 경우, 해당 상품 자동 선택
             */
            state.selectedInfo = data.purchaseDecisionTargets.reduce((acc, cur) => {
                return {
                    ...acc,
                    [cur.productOrderNo]: {
                        checked: data.purchaseDecisionTargets.length === 1 || cur.productOrderNo === clickedId,
                    },
                }
            }, {})
        })
    },
})

export default purchaseConfirmationSlice.reducer
